const skSK= {
    login: {
      title: 'Prihlásiť sa',
      sign_in_btn: 'Prihlásiť sa'
    },
    bar: {
        logout: 'Odhlásiť',
        languages: 'Jazyky',
        settings: 'Otvoriť nastavenia'
    },
    language: {
      name: 'Angličtina (USA)',
    },
    attributePage: {
        title: 'Zmeny atribútov',
        viewChanges: 'Pozrite si zmeny',
        dateTime: 'Dátum',
        notificationType: 'Typ oznámenia',
        notificationValue: 'Obsah oznámenia',
        oldValue: 'Starý obsah',
        newValue: 'Nový obsah',
        accept: 'Prijať',
        reject: 'Odmietnuť',
    },
    Home: 'Domov',
    load: 'Prebieha prvotné nahratie...',
    Requested: "Požadované",
    Viewed: "Zobrazené",
    Executing: "Vykonávanie",
    Completed: "Dokončené",
    Expired: "Vypršala platnosť",
    Cancelled: "Zrušené",
    Error: "Chyba",
    Rejected: "Odmietnuté",
    error: 'Niečo sa pokazilo; skúste to, prosím, neskôr.',
    displayname: 'Zobrazené meno',
    givenname: 'Meno',
    surname: 'Priezvisko',
    email: 'E-mail',
    mail: 'E-mail',
    name: 'Meno',
    firstname: 'Meno',
    lastname: 'Priezvisko',
    footer_copyright: 'Všetky práva vyhradené.'
  };
  
  export default skSK;
  